export default "__VITE_ASSET__jp1G79cq__"